import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import { uploadMaterialFiles, OFFICE_ACCEPT } from "../../utils/uploadMaterialS3";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";

export default function New_Produto({ history }) {
  const [titulo, setTitulo] = useState("");
  const [descr, setDescr] = useState("");
  const [cargaHoraria, setCargaHoraria] = useState("0");
  const [responsavelTecnico, setResponsavelTecnico] = useState("");
  const [loading, setLoading] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [idempresa, setIdempresa] = useState("");
  const [isIntegracao, setIsIntegracao] = useState(false);
  const [corporativo, setCorporativo] = useState(true);
  const [avulso, setAvulso] = useState(false);
  const [valorTreinamento, setValorTreinamento] = useState("");
  const [imgTreinamento, setImgTreinamento] = useState("");
  const [arquivosMaterial, setArquivosMaterial] = useState([]);
  const [uploadingMaterial, setUploadingMaterial] = useState(false);

  const url_string = window.location.href;
  const param = url_string.split("?");

  const isMaster = localStorage.getItem("sgimaster");
  const isMasterUser = isMaster === "true";
  const empresaid = localStorage.getItem("sgiempresaid");
  const reqHeaders = { headers: { "x-tenantid": empresaid, isMaster } };

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    if (!corporativo && !avulso) {
      alert("Marque pelo menos um tipo: Corporativo ou Avulso.");
      setLoading(false);
      return;
    }

    const dataobj = {
      titulo,
      descr,
      data: new Date(),
      idempresa: idempresa,
      isIntegracao: isIntegracao,
      cargaHoraria: cargaHoraria,
      responsavelTecnico: responsavelTecnico,
      corporativo: corporativo ? 1 : 0,
      avulso: avulso ? 1 : 0,
      valor: avulso ? parseFloat(valorTreinamento) || 0 : null,
      img: imgTreinamento.trim() || undefined,
      arquivosMaterial:
        arquivosMaterial.length > 0 ? arquivosMaterial : undefined,
    };

    await api.post("/treinamentos/produto/", dataobj, reqHeaders);
    setLoading(false);
    if(isIntegracao){
      history.push("/integracoes");
    } else {
      history.push("/produtos");
    }
    
  }

  async function loadEmpresas() {
    const query = "/treinamentos/empresa";
    const response = await api.get(query);
    const data = await response.data;
    setEmpresas(data);
    setIdempresa(localStorage.getItem("sgiempresaid"));
    setLoading(false);
  }

  function updateUsuarios(selectedValue) {
    alert(selectedValue);
  }

  async function handleMaterialFileChange(event) {
    const input = event.target;
    const files = input.files;
    if (!files || files.length === 0) return;
    setUploadingMaterial(true);
    try {
      const novos = await uploadMaterialFiles(Array.from(files));
      setArquivosMaterial((prev) => [...prev, ...novos]);
    } catch (e) {
      alert(e.message || "Erro ao enviar arquivo.");
    }
    input.value = "";
    setUploadingMaterial(false);
  }

  function removeMaterialIndex(idx) {
    setArquivosMaterial((prev) => prev.filter((_, i) => i !== idx));
  }

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (document.getElementById("menu_produto_novo")) {
        document.getElementById("menu_produto_novo").className = "active";
      }
    }, 50);
    loadEmpresas();
    if(param[1] == 'integracao=1'){
      setIsIntegracao(true);
    }
    setLoading(false);
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>Novo Produto</h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-info">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80" alt="carregando"></img>
                  </div>
                )}

                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Titulo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Nome do Produto"
                          className="form-control"
                          value={titulo}
                          required
                          onChange={(event) => setTitulo(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Conteúdo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Conteúdo do Treinamento"
                          className="form-control"
                          value={descr}
                          required
                          onChange={(event) => setDescr(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Carga Horária*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Carga Horária do treinamento"
                          className="form-control"
                          value={cargaHoraria}
                          required
                          onChange={(event) => setCargaHoraria(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Responsável Técnico
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="responsavelTec"
                          placeholder="Responsável Técnico Caso NR"
                          className="form-control"
                          value={responsavelTecnico}
                          onChange={(event) => setResponsavelTecnico(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label">Tipo de Treinamento*</label>
                      <div className="col-sm-10">
                        <div className="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={corporativo}
                              disabled={!isMasterUser}
                              onChange={(e) => setCorporativo(e.target.checked)}
                            />
                            {' '}Corporativo
                          </label>
                        </div>
                        <div className="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={avulso}
                              disabled={!isMasterUser}
                              onChange={(e) => {
                                setAvulso(e.target.checked);
                                if (!e.target.checked) setValorTreinamento("");
                              }}
                            />
                            {' '}Avulso
                          </label>
                        </div>
                        <small className="text-muted">
                          {isMasterUser
                            ? "Marque um ou ambos. Pelo menos um deve estar marcado."
                            : "Padrão: Corporativo"}
                        </small>
                      </div>
                    </div>

                    {avulso && (
                      <div className="form-group">
                        <label className="col-sm-2 control-label" htmlFor="valorTreinamento">
                          Valor (R$)*
                        </label>
                        <div className="col-sm-10">
                          <input
                            id="valorTreinamento"
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="0.00"
                            className="form-control"
                            value={valorTreinamento}
                            required
                            onChange={(event) => setValorTreinamento(event.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="imgTreinamento">
                        Imagem (URL)
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="imgTreinamento"
                          type="url"
                          placeholder="https://exemplo.com/imagem.jpg"
                          className="form-control"
                          value={imgTreinamento}
                          onChange={(e) => setImgTreinamento(e.target.value)}
                        />
                        <small className="text-muted">URL da imagem exibida na página Treinamentos Abertos do site.</small>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="materialOffice">
                        Material de Apoio
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="materialOffice"
                          type="file"
                          className="form-control"
                          accept={OFFICE_ACCEPT}
                          multiple
                          disabled={uploadingMaterial}
                          onChange={handleMaterialFileChange}
                        />
                        {uploadingMaterial && (
                          <div style={{ marginTop: 8 }}>
                            <img src={carregando} width="40" alt="enviando" />
                            <span className="text-muted" style={{ marginLeft: 8 }}>
                              Enviando…
                            </span>
                          </div>
                        )}
                        <small className="text-muted">
                          Word, Excel, PowerPoint e formatos relacionados. Ao escolher os arquivos, o envio ao servidor e ao S3 começa automaticamente.
                        </small>
                        {arquivosMaterial.length > 0 && (
                          <ul className="list-unstyled" style={{ marginTop: 10 }}>
                            {arquivosMaterial.map((a, idx) => (
                              <li key={idx} style={{ marginBottom: 6 }}>
                                <a
                                  href={a.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {a.nome || "arquivo"}
                                </a>
                                {" "}
                                <button
                                  type="button"
                                  className="btn btn-xs btn-danger"
                                  onClick={() => removeMaterialIndex(idx)}
                                >
                                  remover
                                </button>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                    <label className="col-sm-2 control-label" htmlFor="nome">
                        Empresa*
                      </label>
                      <div className="col-sm-10">
                      <select
                        id="idcompressor"
                        value={idempresa}
                        placeholder="Empresa do usuário"
                        className="form-control select2"
                        disabled={isMaster == "false"}
                        onChange={(event) => setIdempresa(event.target.value)}
                      >
                        <option key="" value="" disabled>
                          -- Selecione --
                        </option>
                        {empresas.map((empresa) => (
                          <option key={empresa._id} value={empresa._id}>
                            {empresa.nome}
                          </option>
                        ))}
                        <option key={"ALL"} value={"ALL"}>
                            {"Todas"}
                          </option>
                      </select>
                    </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      className="btn btn-default"
                      style={{ marginRight: 8 }}
                      onClick={() => isIntegracao ? history.push("/integracoes") : history.push("/produtos")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div>

                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80" alt="carregando"></img>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
